import React, { useState } from 'react';
import { CheckIcon, CreditCardIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function PricingSection() {
  const [includeColorimetria, setIncludeColorimetria] = useState(false);
  const basePrice = 19990;
  const basePriceOriginal = 49990;
  const colorimetriaPrice = 7000;
  const colorimetriaPriceOriginal = 26990;
  const totalPrice = includeColorimetria ? basePrice + colorimetriaPrice : basePrice;
  const totalPriceOriginal = includeColorimetria ? basePriceOriginal + colorimetriaPriceOriginal : basePriceOriginal;
  const discountPercentage = Math.round((totalPriceOriginal - totalPrice) / totalPriceOriginal * 100);
  const checkoutUrl = includeColorimetria ? 'https://checkout.tuvidasimple.shop/cart/44818150719590:1' : 'https://checkout.tuvidasimple.shop/cart/44818129059942:1';
  return <section id="pricing" className="w-full bg-[#0a0a0a] py-8 md:py-16 px-4" data-id="element-174">
      <div className="max-w-xl mx-auto" data-id="element-175">
        {/* Encabezado */}
        <div className="text-center mb-6 md:mb-10" data-id="element-176">
          <p className="text-xs md:text-sm text-[#c41e3a] font-black tracking-widest uppercase mb-2" data-id="element-177">
            Precio de lanzamiento
          </p>
          <h2 className="text-2xl md:text-4xl font-black text-white leading-tight" data-id="element-178">
            Empezá hoy y transformá tu forma de trabajar
          </h2>
        </div>

        <div className="bg-[#111] rounded-2xl border-2 border-[#c41e3a] shadow-2xl overflow-hidden" data-id="element-179">
          {/* Precio — punto focal */}
          <div className="bg-[#c41e3a]/10 border-b border-[#c41e3a]/30 p-6 md:p-8 text-center" data-id="element-180">
            <div className="inline-block bg-[#c41e3a] text-white px-5 py-1.5 rounded-full font-black text-sm md:text-base mb-4 tracking-wide" data-id="element-181">
              🔥 {discountPercentage}% OFF — Solo por lanzamiento
            </div>
            <div className="mb-1" data-id="element-182">
              <span className="text-lg md:text-2xl text-gray-500 line-through font-bold" data-id="element-183">
                ${totalPriceOriginal.toLocaleString('es-AR')} ARS
              </span>
            </div>
            <div className="flex items-baseline justify-center gap-2 mb-1" data-id="element-184">
              <span className="text-5xl md:text-7xl font-black text-white" data-id="element-185">
                ${totalPrice.toLocaleString('es-AR')}
              </span>
              <span className="text-xl md:text-2xl text-gray-400 font-bold" data-id="element-186">
                ARS
              </span>
            </div>
            {includeColorimetria && <p className="text-gray-400 text-xs md:text-sm font-semibold mt-1" data-id="element-187">
                Método Barber Pro + Colorimetría incluida
              </p>}
          </div>

          {/* Includes */}
          <div className="p-5 md:p-8 space-y-3 border-b border-gray-800" data-id="element-188">
            <p className="text-xs md:text-sm text-gray-400 font-black tracking-widest uppercase mb-3" data-id="element-189">
              Incluye:
            </p>
            {[{
            icon: <ZapIcon className="w-5 h-5 text-[#c41e3a]" data-id="element-190" />,
            text: 'Acceso inmediato al material completo'
          }, {
            icon: <CheckIcon className="w-5 h-5 text-[#c41e3a]" data-id="element-191" />,
            text: 'Ebooks profesionales descargables (PDF)'
          }, {
            icon: <CheckIcon className="w-5 h-5 text-[#c41e3a]" data-id="element-192" />,
            text: 'Videos de apoyo incluidos'
          }, {
            icon: <CheckIcon className="w-5 h-5 text-[#c41e3a]" data-id="element-193" />,
            text: '3 Bonus exclusivos'
          }, {
            icon: <CheckIcon className="w-5 h-5 text-[#c41e3a]" data-id="element-194" />,
            text: 'Certificado digital al completar'
          }].map(({
            icon,
            text
          }) => <div key={text} className="flex items-center gap-3 text-gray-200" data-id="element-195">
                {icon}
                <span className="text-sm md:text-base font-semibold" data-id="element-196">
                  {text}
                </span>
              </div>)}
          </div>

          {/* Order Bump */}
          <div className="p-5 md:p-8 border-b border-gray-800" data-id="element-197">
            <label className="flex items-start gap-4 cursor-pointer group" data-id="element-198">
              <input type="checkbox" checked={includeColorimetria} onChange={e => setIncludeColorimetria(e.target.checked)} className="w-5 h-5 mt-0.5 rounded border-2 border-gray-500 text-[#c41e3a] focus:ring-2 focus:ring-[#c41e3a] cursor-pointer flex-shrink-0" aria-label="Agregar formación en Colorimetría" data-id="element-199" />
              <div className="flex-1" data-id="element-200">
                <span className="text-white text-sm md:text-base font-black block mb-1" data-id="element-201">
                  🎨 Sumar Colorimetría aplicada al pack
                </span>
                <span className="text-gray-400 text-xs md:text-sm block mb-2" data-id="element-202">
                  Aprendé a trabajar con color de forma profesional
                </span>
                <div className="flex items-center gap-2" data-id="element-203">
                  <span className="text-gray-500 line-through text-sm font-semibold" data-id="element-204">
                    ${colorimetriaPriceOriginal.toLocaleString('es-AR')}
                  </span>
                  <span className="text-[#c41e3a] font-black text-lg" data-id="element-205">
                    +${colorimetriaPrice.toLocaleString('es-AR')}
                  </span>
                </div>
              </div>
            </label>
          </div>

          {/* CTA */}
          <div className="p-5 md:p-8" data-id="element-206">
            <a href={checkoutUrl} target="_self" rel="noopener" className="cta-primary block w-full text-white font-black text-base md:text-xl py-4 md:py-5 rounded-xl text-center no-underline mb-3" aria-label="Acceder a la formación ahora" data-id="element-207">
              👉 Quiero empezar ahora
            </a>
            <div className="flex items-center justify-center gap-4 text-gray-500 text-xs" data-id="element-208">
              <div className="flex items-center gap-1" data-id="element-209">
                <CreditCardIcon className="w-4 h-4" data-id="element-210" />
                <span data-id="element-211">Mercado Pago</span>
              </div>
              <span data-id="element-212">·</span>
              <div className="flex items-center gap-1" data-id="element-213">
                <ShieldCheckIcon className="w-4 h-4" data-id="element-214" />
                <span data-id="element-215">Compra segura</span>
              </div>
              <span data-id="element-216">·</span>
              <div className="flex items-center gap-1" data-id="element-217">
                <ZapIcon className="w-4 h-4" data-id="element-218" />
                <span data-id="element-219">Acceso inmediato</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}